import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'

import s from './styles.module.scss'

export const ChildAvailable = () => {
  const { t } = useTranslation()

  return (
    <div className={s.container}>
      <p className={clsx(s.title, 'bold-17')}>
        {t('beket.for_passenger_whit_child')}
      </p>

      <div className={s.flex}>
        <div className={s.info}>
          <AppIcon
            className={s.checkIcon}
            id={AllIcons.CHECK_ROUNDED}
            height={16}
            width={16}
          />

          <p className={clsx(s.text, 'regular-12')}>
            {t('beket.child_condition')}
          </p>
        </div>

        <div className={s.info}>
          <AppIcon
            className={s.infoIcon}
            id={AllIcons.INFO_ROUNDED}
            height={16}
            width={16}
          />
          <p className={clsx(s.text, 'regular-12')}>
            {t('beket.birth_certificate_notice')}
          </p>
        </div>
      </div>
    </div>
  )
}
